/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrokerageRegionIdentifier
 */
export interface BrokerageRegionIdentifier {
}

/**
 * Check if a given object implements the BrokerageRegionIdentifier interface.
 */
export function instanceOfBrokerageRegionIdentifier(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BrokerageRegionIdentifierFromJSON(json: any): BrokerageRegionIdentifier {
    return BrokerageRegionIdentifierFromJSONTyped(json, false);
}

export function BrokerageRegionIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerageRegionIdentifier {
    return json;
}

export function BrokerageRegionIdentifierToJSON(value?: BrokerageRegionIdentifier | null): any {
    return value;
}

